module.exports = __webpack_public_path__ + "img/dandomainlogo.79f0470d.png";